import * as yup from "yup"
import { translate } from "../i18n"
import zxcvbn from "zxcvbn"

yup.addMethod(yup.string, 'ascii', function(message) {
  return this.test('ascii', message, function (value) {
    const isValid = /^[\t\n\r -~]+$/.test(value);
    if (isValid) return isValid;
    return this.createError({
      message: translate("yup.string.ascii")
    })
  });
});

yup.addMethod(yup.string, 'emailOrPhone', function(message) {
  const phoneRegExp = /^\+?(\d+)+$/

  return this.test('emailOrPhone', message, function (value) {
    if (!value) return true
    const isValidPhone = yup.string().min(10).max(15).matches(phoneRegExp).isValidSync(value);
    const isValidEmail = yup.string().email().isValidSync(value);

    if (isValidPhone || isValidEmail) return isValidPhone || isValidEmail;
    return this.createError({
      message: translate("yup.string.emailOrPhone")
    })
  });
});

yup.addMethod(yup.string, 'zxcvbn', function(minScore, message) {
  return this.test('zxcvbn', message, function (value) {
    if (!value) return true
    const result = zxcvbn(value)
    if (result.score >= minScore) return true;
    return this.createError({
      message: translate("yup.string.zxcvbn")
    })
  });
});
